import React from 'react';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Space, Spin } from 'antd';
import { FormInstance } from 'antd/es/form';
import useProjectPresetsSearchQuery from '../../hooks/query/useProjectPresetsSearchQuery';
import { ProjectPresetsResponse } from 'osep-generator-service-client-v1';

type Props = {
  form: FormInstance;
  type: string;
  onAddDefault: () => void;
};

const ProjectPresetsDropdown = ({ form, type, onAddDefault }: Props) => {
  const { data: projectPresets, isLoading } = useProjectPresetsSearchQuery({
    type: [type],
  });

  const handleMenuClick = ({ key }: { key: string }) => {
    if (key === 'add-new') {
      onAddDefault();
      return;
    }

    const selectedCredential = projectPresets?.find(
      (defaults: ProjectPresetsResponse) => defaults.id.toString() === key,
    );

    if (selectedCredential) {
      const mappedData = selectedCredential.params.reduce(
        (acc, param) => {
          acc[param.name] = param.value;
          return acc;
        },
        {} as Record<string, any>,
      );

      form.setFieldsValue({
        ...mappedData,
      });
    }
  };

  const menuItems = isLoading
    ? [
        {
          label: <Spin size="small" tip="Loading..." />,
          key: 'loading',
          disabled: true,
        },
      ]
    : [
        ...(projectPresets?.map((preset) => ({
          key: preset.id.toString(),
          label: preset.name,
        })) || [
          {
            label: 'No data found',
            key: 'no-data',
            disabled: true,
          },
        ]),
        { type: 'divider' as const },
        {
          key: 'add-new',
          label: (
            <Space>
              <PlusOutlined />
              Add Project Preset
            </Space>
          ),
        },
      ];

  const menu = (
    <Menu
      items={menuItems}
      onClick={handleMenuClick}
      style={{ maxHeight: '300px', overflowY: 'auto' }}
    />
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
      <button
        type="button"
        style={{
          border: 'none',
          background: 'none',
          padding: 0,
          cursor: 'pointer',
          color: '#1677ff',
          textDecoration: 'underline',
          outline: 'none',
          font: 'inherit',
        }}
      >
        <Space>
          Apply Preset
          <DownOutlined />
        </Space>
      </button>
    </Dropdown>
  );
};

export default ProjectPresetsDropdown;
